import React from 'react'
import { SectionCard } from './SectionCard'
import styles from './styles.module.css'

export const IngredientsSection = ({ ingredients = [], allergicIngredients = [] }) => {
  const list = [...new Set((ingredients || []).map((s) => String(s).trim()).filter(Boolean))]
  const allergic = [
    ...new Set((allergicIngredients || []).map((s) => String(s).trim()).filter(Boolean)),
  ]

  if (!list.length && !allergic.length) return null

  return (
    <SectionCard title='Ingredients'>
      <div className={styles.ingredientsReadonlyRow}>
        <div className={styles.ingredientsReadonlyCol}>
          <div className={styles.readOnlyFieldLabel}>Ingredients</div>
          {list.length ? (
            <ul className={styles.readOnlyList}>
              {list.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          ) : (
            <div className={styles.readOnlyEmpty}>—</div>
          )}
        </div>
        <div className={styles.ingredientsReadonlyCol}>
          <div className={styles.readOnlyFieldLabel}>Allergic ingredients</div>
          {allergic.length ? (
            <ul className={styles.readOnlyList}>
              {allergic.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          ) : (
            <div className={styles.readOnlyEmpty}>—</div>
          )}
        </div>
      </div>
    </SectionCard>
  )
}
